// extracted by mini-css-extract-plugin
export default {"controls":"CommentEdit_controls__nbQdw","field":"CommentEdit_field__bLbAH"};